export default "__VITE_ASSET__BfhyEt4Y__"